




export const userService = {
    login,
    logout,
    register
};

function login(username:string, password:string) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ Username:username, Password:password })
    };

    return fetch(`https://webscouten.com/api/Auth`, requestOptions)
        .then(handleResponse)
        .then(user => {
            // login successful if there's a user in the response
            if (user.Data) {
                debugger
                localStorage.setItem('UserData', JSON.stringify(user.Data));
                localStorage.setItem('Token', JSON.stringify(user.Data.Token));
            }

            return user;
        });
}
function register(values:any) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify( values )
    };

    return fetch(`https://webscouten.com/api/Users/Register`, requestOptions)
        .then(handleResponse)
        .then(user => {
            return user;
        });
}
function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
}



function handleResponse(response:any) {
    return response.text().then((text :any )=> {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                // location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}
